<template>
  <div class="socialMediaCardContainer">
    <a :href="linkData.path" target="_blank">
      <div class="socialMediaCard">
        <i :class="linkData.symbol"></i>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  name: "community-icon-button",
  props: ["linkData"],
};
</script>
<style scoped lang="scss">
a,
a:visited,
a:hover,
a:link,
a:active {
  color: inherit;
  text-decoration: none;
}

.socialMediaCard {
  width: 200px;
  height: 200px;
  background-color: #141a3c;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.2);
}

.socialMediaCardContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 220px;
  margin-bottom: 20px;
}

.socialMediaCard:hover {
  background-color: #555;
  width: 220px;
  height: 220px;
  transition: 0.5s;
}

.socialMediaCard:not(:hover) {
  transition: 0.5s;
}

.socialMediaCard .fab {
  margin: 0 auto;
}
</style>
